<div class="row shadow title-list bg-white rounded">
    <div class="col-lg-2 pl-5 pt-2">
        <h1 class="lblTitle-02">
            {{ 'cae-user.lblTitle' | translate }}
        </h1>
    </div>
    <div class="col-lg-10 pr-5">
        <form [formGroup]="fmFilters" (ngSubmit)="onLoadGrid(false)" class="w-100-p" autocomplete="off">
            <div class="row pr-5">
                <div class="col-lg-6"></div>

                <div class="col-lg-4 col-md-3 col-sm-12">
                    <mat-form-field appearance="outline" class="search-field">
                        <mat-label> {{ 'cae-user.lblSearch' | translate}}</mat-label>
                        <input formControlName="txtSearch" type="text" matInput maxlength="50" autocomplete="off"
                            data-valid="notnumber">
                        <button disabled="true" class="btn-serch-field">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="col-lg-2 mt-1">
                    <div class="btn-group">
                        <button type="button" class="btn btn-primary mr-3 w-120-px" (click)="onLoadGrid(true)">
                            <i class="fas fa-search text-white mr-2"></i>
                            {{ 'common.btnSearch' | translate }}
                        </button>

                        <button type="button" class="btn btn-secondary flex-justif-alig-center w-100-px"
                            (click)="removeFilter()">
                            <i class="fas fa-times mr-2"></i>
                            {{ 'common.btnClear' | translate }}
                        </button>

                    </div>
                </div>
            </div>
        </form>
    </div>
</div>

 

<!-- LISTADO -->
<div class="row">
    <div class="content-wrap">
        <table class="table table-custom table-hover table-sm table-grid-responsive">
            <caption></caption>
            <thead class="th-custom">
                <tr> 
                    <th class="th-grid-responsive">{{ 'cae-user.gridColumns.Id' | translate }}</th>
                    <th class="th-grid-responsive">{{ 'cae-user.gridColumns.FullName' | translate }}</th>
                    <th class="th-grid-responsive">{{ 'cae-user.gridColumns.Email' | translate }}</th>
                    <th class="th-grid-responsive">{{ 'cae-user.gridColumns.Position' | translate }}</th>
                    <th class="th-grid-responsive">{{ 'cae-user.gridColumns.Status' | translate }}</th>
                    <th class="th-grid-responsive">{{ 'cae-user.gridColumns.InitDate' | translate }}</th>
                    <th class="th-grid-responsive">{{ 'cae-user.gridColumns.EndDate' | translate }}</th>
                    <th class="text-center w-160-px"></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let data of dataInformation">
                    <tr class="tr-custom"> 
                        <td class="td-grid-responsive">
                            <span class="th-name-col">{{ 'cae-user.gridColumns.Id' | translate }}</span>
                            <span class="td-value-row"> {{ data.id }} </span>
                        </td>
                        <td class="td-grid-responsive">
                            <span class="th-name-col">{{ 'cae-user.gridColumns.FullName' | translate }}</span>
                            <span class="td-value-row"> {{ data.name }} </span>
                        </td>
                        <td class="td-grid-responsive">
                            <span class="th-name-col">{{ 'cae-user.gridColumns.Email' | translate }}</span>
                            <span class="td-value-row"> {{ data.email }} </span>
                        </td>
                        <td class="td-grid-responsive">
                            <span class="th-name-col">{{ 'cae-user.gridColumns.position' | translate }}</span>
                            <span class="td-value-row"> {{ data.position }} </span>
                        </td>
                        <td class="td-grid-responsive">
                            <span class="th-name-col">{{ 'cae-user.gridColumns.Status' | translate }}</span>

                            <span class="td-value-row" *ngIf="!data.enable">
                                {{ 'cae-user.gridColumns.StatusDisable' | translate }}
                            </span>

                            <span class="td-value-row" *ngIf="data.enable">
                                {{ 'cae-user.gridColumns.StatusEnable' | translate }}
                            </span>

                        </td>
                        <td class="td-grid-responsive">
                            <span class="th-name-col">{{ 'cae-user.gridColumns.InitDate' | translate }}</span>
                            <span class="td-value-row"> {{ data.periodStartDate | date:'dd/MM/yyyy HH:mm' }} </span>
                        </td>
                        <td class="td-grid-responsive">
                            <span class="th-name-col">{{ 'cae-user.gridColumns.EndDate' | translate }}</span>
                            <span class="td-value-row"> {{ data.periodEndDate | date:'dd/MM/yyyy HH:mm' }} </span>
                        </td>
                        <td class="text-center td-content-btn td-grid-responsive ">
                            <button matTooltip="{{ 'cae-user.gridColumns.EditRecord' | translate }}" type="button"
                                class="btn-none" (click)="onEditItem(data.id, mdlEdit)">
                                <mat-icon class="icon-table flex">edit</mat-icon>
                            </button>
                        </td>
                    </tr>
                </ng-container>
                <tr *ngIf="this.emptyDataList && this.IsPostBack" class="grid-empty text-center bg-light">
                    <td colspan="12" class="mt-3 h-360-px justify-all-center">
                        <img class="img-folder-empty" src="assets/images/icon/Folder.svg" alt="empty folder">
                        <br>
                        <span class="text-info-gray fw-w-bold">
                            {{'common.msgEmptyGrid' | translate}}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="row mt-1 mr-4">
            <div class="col-md-12 mb-5 d-flex justify-content-end">
                <app-pagination-table [totalPages]="totalPages" [currentPage]="currentPage"
                    (changePage)="changePage($event)"></app-pagination-table>
            </div>
        </div>
    </div>
</div>





<ng-template #mdlCreate>
    <div class="row">
        <div class="col-md-12">
            <app-create-cae-user></app-create-cae-user>
        </div>
    </div>
</ng-template>

<ng-template #mdlEdit>
    <div class="row ">
        <div class="col-md-12">
            <app-edit-cae-user [childId]="idEntity"></app-edit-cae-user>
        </div>
    </div>
</ng-template>

<ng-template #mdlUpload>
    <div class="row ">
        <div class="col-md-12">
            <app-upload-cae-users></app-upload-cae-users>
        </div>
    </div>
</ng-template>